<template>
  <ul>
    <li v-for="(item, index) in videoSrcs" :key="index"><a @click="showVideo(item.link)">{{'0' + (index + 1) + '.' + item.content}}</a></li>
  </ul>
  <div class="video_container" v-if="videoVisible">
    <div class="mask"></div>
    <el-icon class="close_btn" @click="closeVideo"><circle-close /></el-icon>
    <video :src="videoSrc" controls autoplay></video>
  </div>
</template>

<script>
export default {
  name: "帮助中心",
  props: {
    currentUser: Object
  },
  data() {
    return {
      videoSrcs: [],
      videoVisible: false,
      videoSrc: null
    }
  },
  methods: {
    showVideo(src) {
      this.videoVisible = true
      this.videoSrc = src
    },
    closeVideo() {
      this.videoVisible = false
    }
  },
  created() {
    const type = this.currentUser.type === 0 ? 0 : null
    this.$apis.common.helpVideo(type).then(response => {
      this.videoSrcs = response.data.data
    })
  }
}
</script>

<style scoped>
ul {
  margin-left: 20px;
}
ul li {
  height: 36px;
  line-height: 36px;
  text-align: left;
}
ul li a {
  font-size: 13px;
  color: #409EFF;
  text-decoration: underline;
  cursor: pointer;
}
</style>